export default __webpack_public_path__ + "static/media/hate-me.f974cf42.jpg";